// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-export-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 5px;
}
.invoice-export-bar .export-progress-label {
  white-space: nowrap;
}
.invoice-export-bar .progress-bar-container {
  flex: 1 1;
}
.invoice-export-bar .export-error {
  color: #b00020;
}

.custom-button.invoice-export-bar-secondary {
  background-color: transparent;
  color: #1d0f40;
  border: 1px solid #1d0f40;
}
.custom-button.invoice-export-bar-secondary:hover {
  background-color: rgba(29, 15, 64, 0.08);
  box-shadow: none;
  color: #1d0f40;
}`, "",{"version":3,"sources":["webpack://./src/components/invoice-export-bar/invoice-export-bar.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,SAAA;AAAJ;AAGE;EACE,cAAA;AADJ;;AASA;EACE,6BAAA;EACA,cAAA;EACA,yBAAA;AANF;AAQE;EACE,wCAAA;EACA,gBAAA;EACA,cAAA;AANJ","sourcesContent":[".invoice-export-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 5px;\n\n  .export-progress-label {\n    white-space: nowrap;\n  }\n\n  .progress-bar-container {\n    flex: 1;\n  }\n\n  .export-error {\n    color: #b00020;\n  }\n}\n\n// Scoped to this feature and given compound specificity so it can't be\n// shadowed by unrelated global classes named \"secondary\" elsewhere in the\n// app's (unscoped) stylesheets, and reliably overrides .custom-button's\n// own rules regardless of CSS bundle order.\n.custom-button.invoice-export-bar-secondary {\n  background-color: transparent;\n  color: #1d0f40;\n  border: 1px solid #1d0f40;\n\n  &:hover {\n    background-color: rgba(29, 15, 64, 0.08);\n    box-shadow: none;\n    color: #1d0f40;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
